import React from 'react';
import { GlobeIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
export function FinalCTA() {
  return <section className="w-full bg-navy-deep" data-id="element-126" data-mp="3mujt7fpda4qk">
      <div className="mx-auto max-w-3xl px-5 py-14 text-center sm:py-20" data-id="element-127" data-mp="3mrnxzz4wlu5t">
        <h2 className="font-display text-[1.7rem] font-bold leading-[1.15] tracking-tight text-white sm:text-4xl" data-id="element-128" data-mp="3rraag6cwr6dk">
          Your Next Menopause Consultation Doesn't Have to Feel{' '}
          <span className="text-gold" data-id="element-129" data-mp="3hvqke0l0z1wq">Uncertain.</span>
        </h2>
        <p className="mt-4 text-[15px] leading-relaxed text-white/75" data-id="element-130" data-mp="33v5ygvjtcpz0">
          You don't need another textbook. You don't need another guideline. You
          need a clinical system that helps you make the right decision—every
          single time.
        </p>

        <p className="mt-8 text-[12px] font-bold uppercase tracking-[0.16em] text-white/50" data-id="element-131" data-mp="121gdxzzk8jt2">
          Today only
        </p>
        <p className="font-display text-[4rem] font-bold leading-none text-gold" data-id="element-132" data-mp="q8dhv0nc12tt">
          $27
        </p>

        <div className="mt-6" data-id="element-133" data-mp="la280px1esbl">
          <CTAButton variant="gold" label="Yes, I want the complete Blueprint" data-id="element-134" data-mp="l8r5suj8psml" />
        </div>

        <div className="mt-6" data-id="element-135" data-mp="z31kej1iw6ex">
          <Countdown tone="dark" data-id="element-136" data-mp="uzlt82882y9m" />
        </div>

        <div className="mt-6" data-id="element-137" data-mp="uzvifnlg11e9">
          <ScarcityBar tone="dark" data-id="element-138" data-mp="79rflig2x5ob" />
        </div>

        <p className="mt-6 flex items-center justify-center gap-2 text-[12.5px] font-medium text-white/60" data-id="element-139" data-mp="7akczst5eits">
          <GlobeIcon className="h-4 w-4 text-gold" data-id="element-140" data-mp="2c935i2us8bk" />
          Automatic currency conversion to your country
        </p>
        <p className="mt-2 text-[13px] font-semibold leading-relaxed text-white/70" data-id="element-141" data-mp="g8ct2z6p1ui8">
          Instant Access • One-Time Payment • Lifetime Access • 7-Day
          Money-Back Guarantee
        </p>
      </div>

      <footer className="border-t border-white/10 px-5 py-8 text-center" data-id="element-142" data-mp="1rrfmpazn9owa">
        <p className="font-display text-base font-bold text-white" data-id="element-143" data-mp="1mq9qv4aotlij">
          Dr. <span className="text-gold" data-id="element-144" data-mp="kc2559gb2dks">Karito</span>
        </p>
        <p className="mx-auto mt-3 max-w-xl text-[11.5px] leading-relaxed text-white/45" data-id="element-145" data-mp="pc6kux9e349y">
          The Menopause Clinical Blueprint™ is an educational resource for
          licensed healthcare professionals. It does not replace clinical
          judgment, local regulations, or individualized patient care.
        </p>
        <p className="mt-4 text-[11.5px] text-white/35" data-id="element-146" data-mp="1nf02qy4po77">
          © {new Date().getFullYear()} Dr. Karito. All rights reserved.
        </p>
      </footer>
    </section>;
}